import { ContactDto } from "../contact/models/contact"
import { Entity } from "../helpers/Entity"

export type CompanyDescriptionAttributesDto = {
    accountId: string
    organization: ContactDto
}

export type CompanyDescriptionDto = {
    id: string
    type: string
    attributes: CompanyDescriptionAttributesDto
}

export default class CompanyDescription implements Entity {
    private dto: CompanyDescriptionDto

    constructor(dto: CompanyDescriptionDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "company-descriptions"
    }

    getId(): string {
        return this.dto.id
    }

    getDefaultCountryCode(): string {
        return this.dto.attributes.organization.attributes.address.countryCode
    }
}



// WEBPACK FOOTER //
// ./src/state/companyDescription/CompanyDescription.ts